<template>
	<div>
		<v-data-table
			:headers="headers"
			:items="radio_list"
			:items-per-page="-1"
			hide-default-header
			hide-default-footer
		>
			<template v-slot:header="{ props: { headers } }">
				<thead>
					<tr>
						<th v-for="header in headers" :key="header.value" style="border-top: thin solid rgba(0, 0, 0, 0.2)" :style="(header.value === 'status' || header.value === 'revenue') ? 'border-right: thin solid rgba(0, 0, 0, 0.12)': ''">
							<v-row class="ma-0 px-3" :class="middle_header.includes(header.value) ? 'header-background-color':''" :style="`width: ${header.width}px`" v-for="(header_item, index) in header.text" :key="`${index}_${header.value}`">
								<span class="font-bold-style font-header-style" style="line-height: 36px;">{{ header_item }}&nbsp;</span>
							</v-row>
						</th>
					</tr>
				</thead>
			</template>
			<template v-slot:body="{ items, headers }">
				<tbody>
					<template v-if="items.length === 0">
						<tr>
							<td :colspan="headers.length">
								<v-row class="font-normal-style font-header-style ma-0 px-3" justify="center" style="line-height: 24px">
									<div>&nbsp;&nbsp;</div>
								</v-row>
							</td>
						</tr>
					</template>
					<template v-else>
						<tr v-for="(item_obj, index) in items" :key="index">
							<td v-for="(item, key) in filterItem(item_obj)" :key="key" :style="(key === 'status' || key === 'revenue') ? 'border-right: thin solid rgba(0, 0, 0, 0.12)': ''">
								<div v-if="key === 'booking_station'" style="width: 180px">
									<v-row justify="start" align="start" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap;" v-for="(booking_station, index) in item" :key="`${index}_booking_station`">
										<v-card tile elevation="0" color="transparent">
											<span v-if="index === 0" class="font-normal-style truncate-2 font-header-style">{{ typeof(item[0]) === 'string' ? item[0] :item[0].station_desc }}&nbsp;</span>
											<template v-if="index === 1">
												<v-text-field
													v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
													class="field-in-cell-name font-normal-style font-header-style"
													:color="color"
													v-model="item_obj.booking_station[1]"
													outlined
													dense
													hide-details
													height="24"
												>
												</v-text-field>
												<span v-else class="font-normal-style font-header-style">{{ booking_station }}&nbsp;</span>
											</template>
										</v-card>
									</v-row>
								</div>
								<div v-if="key === 'reference'" style="width: 200px">
									<v-row justify="start" align="start" class="font-bold-style font-header-style mx-0 my-1 px-2" v-for="(reference, index) in item" :key="`${index}_station`">
										<v-card tile elevation="0" color="transparent">
											<span class="font-normal-style truncate-2 font-header-style">{{ reference }}&nbsp;</span>
											<v-btn v-if="item" icon small class="ml-1" @click.stop="onHistoryClick(reference)">
												<v-icon color="rgba(25, 42, 62, 0.25)" size="22">mdi-history</v-icon>
											</v-btn>
										</v-card>
									</v-row>
								</div>
								<div v-if="key === 'duration'" style="width: 120px">
									<v-row justify="start" align="start" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap" v-for="(duration, index) in item" :key="`${index}_station`">
										<span class="font-normal-style font-header-style">{{ duration }}&nbsp;</span>
									</v-row>
								</div>
								<div v-if="key === 'time'" style="width: 120px">
									<v-row justify="start" align="start" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap;" v-for="(time, index) in item" :key="`${index}_station`">
										<span class="font-normal-style font-header-style">{{ time }}&nbsp;</span>
									</v-row>
								</div>
								<div v-if="key === 'date'" style="width: 180px">
									<v-row justify="start" align="start" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap; height: 24px" v-for="(date, index) in item" :key="`${index}_station`">
										<v-row v-if="index === 0" class="ma-0"  style="flex-wrap: nowrap;" align="center">
											<div style="width: 20px; height: 20px">
												<Calendar :color="'rgba(25, 42, 62, 0.5)'" width="20" height="20"/>
											</div>
											<div class="ml-2 font-normal-style font-header-style" style="min-width: 100px;text-align: start;line-height: 16px">{{ formatDate(date) }}</div>
										</v-row>
										<template v-else>
											<div
												v-for="(weekday, index_weekday) in weekday"
												:key="`${index_weekday}_weekday`"
												style="width: 20px; height: 20px"
												:class="date[`${index_weekday}`] === '1' ? (item_obj.is_edit ? 'weekday-block-plan':'weekday-block-other'):'weekday-block'"
											>
												{{ weekday }}
											</div>
										</template>
									</v-row>
								</div>
								<div v-if="key === 'status'" style="width: 200px">
									<v-row class="ma-0 px-2" style="flex-wrap: nowrap;" align="center">
										<v-chip v-if="!bookingEdit || !ableStatus || item_obj.status.key === 'reversed' || item_obj.status.key === 'reversal' || item_obj.status.key === 'unapproved' || item_obj.status.key === 'test_invoice' || item_obj.status.key === 'note' || ((item_obj.status.key === 'booked' || item_obj.status.key === 'planned') && item_obj.has_po) || (item_obj.status.key === 'planned' && item_obj.id === 0) || (item_obj.status_original_id === 4 && (!ableInv  || (ableInv && item_obj.has_cinv)))"
											class="text-capitalize white--text mr-1"
											style="min-width: 140px;"
											label 
											:color="item_obj.status.color">
											{{ item_obj.status.text }}
										</v-chip>
										<v-select
											v-else
											class="select-in-cell text-capitalize mr-1"
											style="max-width: 136px;"
											v-model="item_obj.status"
											color="#FFFFFF"
											:background-color="item_obj.status.color"
											:menu-props="{ bottom: true, offsetY: true}"
											:items="filterStatus(item_obj.status_original_id)"
											item-color="media"
											solo
											flat
											dense
											hide-details
											return-object
											@change="onStatusChange($event, item_obj)"
										>
											<template v-slot:append="">
												<v-icon color="#FFFFFF">mdi-chevron-down</v-icon>
											</template>
											<template v-slot:selection="{ item }">
												<span class="white--text">{{ item.text }}</span>
											</template>
											<template v-slot:item="{item, on}">
												<v-list-item v-on="on" dense>
													<div v-if="item.last" :class="item.last && item_obj.status.key !== item.key ? 'pt-2':'' ">
														<v-badge
															:color="item.color"
															left
															inline
														>
															<span :class="item_obj.status.key === item.key ? 'font-bold-style selector-item-style':'font-normal-style font-header-style'">{{ item.text }}</span>
														</v-badge>
														<v-alert
															class="mt-0 mb-0"
															style="width: 240px; line-height: 20px; padding: 0 0 0 2px;"
															dense
															text
															type="warning"
															icon="mdi-alert-circle"
														>
															<span class="font-normal-style font-header-style">Note: Change of status here won’t create a PO or invoice. </span>	
														</v-alert>
													</div>
													<div v-else>
														<v-badge
															:color="item.color"
															left
															inline
														>
															<span :class="item_obj.status.key === item.key ? 'font-bold-style selector-item-style':'font-normal-style font-header-style'">{{ item.text }}</span>
														</v-badge>
													</div>
												</v-list-item>
											</template>
										</v-select>
										<v-tooltip v-if="item_obj.status.delete && item_obj.status.value.includes(planned_value) && !item_obj.has_po" top max-width="300" color="#192A3E">
											<template v-slot:activator="{ on, attrs }">
												<v-btn class="disable-btn" small icon v-bind="attrs" v-on="on" :disabled="!ableDelete || !bookingEdit"  @click.stop="onDeleteBooking(item_obj)">
													<Delete
														class="ml-2 mt-1"
														:color="ableDelete ? 'rgba(25, 42, 62, 0.6)' :'rgba(0, 0, 0, 0.26)'" 
														width="20" 
														height="20"
													/>	
												</v-btn>
											</template>
											<span v-if="ableDelete">Delete booking</span>
											<span v-else>Insufficient privileges to use this function. Please contact your system administrator if this is incorrect.</span>
										</v-tooltip>
										<v-tooltip v-if="!item_obj.status.delete" top color="#192A3E">
											<template v-slot:activator="{ on, attrs }">
												<v-btn small icon v-bind="attrs" v-on="on" :disabled="!ableEdit || !bookingEdit" @click.stop="onReverseBooking(item_obj)">
													<v-icon :color="'rgba(25, 42, 62, 0.6)'" small class="ml-1">mdi-backspace-reverse-outline</v-icon>
												</v-btn>
											</template>
											<span>Reverse booking</span>
										</v-tooltip>
									</v-row>
								</div>
								<div v-if="key === 'cost'" style="width: 140px">
									<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 my-1 pl-4 pr-2" style="flex-wrap: nowrap; height: 24px" v-for="(cost, index) in item_obj.cost" :key="`${index}_currency`">
										<span class="font-normal-style" :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'">{{ cost }}&nbsp;</span>
									</v-row>
								</div>
								<div v-if="key === 'supplier'" style="width: 160px">
									<v-row justify="space-between" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap; line-height: 24px" v-for="(supplier, index) in item_obj.supplier" :key="`${index}_supplier`">
										<span v-if="item_obj.cost_currency" class="selector-item-style mr-1">{{ item_obj.cost_currency.code }}&nbsp;</span>
										<v-text-field
											v-if="index === 0 && item_obj.status.value.includes(planned_value) && !item_obj.has_po && bookingEdit"
											class="field-in-cell font-normal-style"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											style="text-align: end;align-items: end; color:blue"
											:value="numberFormat(supplier)"
											:color="color"
											:disabled="!ableEdit"
											outlined
											dense
											hide-details
											height="24"
											@change="onChangeSupplier($event, item_obj.index)"
										>
										</v-text-field>
										<span v-if="index === 0 && (!item_obj.status.value.includes(planned_value) || item_obj.has_po || !bookingEdit)" :class="item_obj.status.value.includes(reversal_value)? 'reversal-text-color':'font-header-style'" style="font-weight: 400;">{{ numberFormat(supplier) }}&nbsp;</span>
										<span v-if="index === 1" :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'" style="font-weight: 400;">{{ numberFormat(supplier) }}&nbsp;</span>
									</v-row>
								</div>
								<div v-if="key === 'commission'" style="width: 140px">
									<v-row class="font-normal-style font-header-style  mx-0 my-1 px-1" style="flex-wrap: nowrap; line-height: 24px" v-for="(commission, index) in item_obj.commission" :key="`${index}_commission`">
										<v-text-field
											v-if="ableEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
											class="field-in-cell font-normal-style"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											style="text-align: end;align-items: end"
											:value="numberFormat(commission)"
											:color="color"
											outlined
											dense
											hide-details
											height="24"
											@change="onChangeCommission($event, item_obj.index, index)"
										>
											<template v-slot:prepend>
												<v-icon v-if="index === 0" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-currency-usd</v-icon>
												<v-icon v-if="index === 1" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
											</template>
										</v-text-field>
										<v-row v-if="!ableEdit || !item_obj.status.value.includes(planned_value) || item_obj.has_po" class="ma-0 pr-3" justify="space-between">
											<v-icon v-if="index === 0" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-currency-usd</v-icon>
											<v-icon v-if="index === 1" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
											<div :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'">{{ numberFormat(commission) }}&nbsp;</div>
										</v-row>
									</v-row>
								</div>
								<div v-if="key === 'schedule'" style="width: 140px">
									<v-row justify="start" align="center" class="font-bold-style font-header-style mx-0 my-1 pl-4 pr-2" style="flex-wrap: nowrap; height: 24px" v-for="(schedule, index) in item_obj.schedule" :key="`${index}_schedule`">
										<span class="font-normal-style" :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'">{{ schedule }}&nbsp;</span>
									</v-row>
								</div>
								<div v-if="key === 'net'" style="width: 160px">
									<v-row justify="space-between" align="center" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap; line-height: 24px" v-for="(net, index) in item_obj.net" :key="`${index}_net`">
										<span v-if="item_obj.schedule_currency" class="selector-item-style mr-1">{{ item_obj.schedule_currency.code }}&nbsp;</span>
										<v-text-field
											v-if="ableEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
											class="field-in-cell font-normal-style"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											style="text-align: end;align-items: end"
											:value="numberFormat(net)"
											:color="color"
											outlined
											dense
											hide-details
											height="24"
											@change="onChangeNet($event, item_obj.index)"
										>
										</v-text-field>
										<v-text-field
											v-if="!ableEdit || !item_obj.status.value.includes(planned_value) || item_obj.has_po"
											class="field-in-cell font-normal-style pr-1"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											style="text-align: end;align-items: end"
											:value="numberFormat(net)"
											:color="color"
											background-color="transparent"
											filled
											rounded
											disabled
											dense
											hide-details
											height="24"
										>
										</v-text-field>
									</v-row>
								</div>
								<div v-if="key === 'foc'" style="width: 56px">
									<v-row justify="center">
										<v-checkbox
											class="mt-0 pt-0"
											v-model="item_obj.foc"
											:color="color"
											:disabled="!tickableFOC(item_obj) || !ableEdit"
											hide-details
											dense
											@change="onChangeFOC($event, item_obj.index)"
										></v-checkbox>
									</v-row>
								</div>
								<div v-if="key === 'mode'" style="width: 160px">
									<v-row justify="center" class="px-2">
										<v-select
											class="select-in-cell"
											:value="item_obj.mode"
											:items="mode_items"
											:color="color"
											:disabled="item_obj.foc === true || !item_obj.status.value.includes(planned_value) || item_obj.has_po  || !ableEdit || !bookingEdit"
											item-color="media"
											:menu-props="{ bottom: true, offsetY: true}"
											background-color="transparent"
											append-icon="mdi-chevron-down"
											dense
											hide-details
											solo
											flat
											return-object
											@change="onChangeMode($event, item_obj.index)"
										>
											<template v-slot:selection="{ item, disabled }">
												<span class="font-normal-style font-header-style" style="line-height: 24px;" :style="disabled ? 'color:rgba(0, 0, 0, 0.38)':''">{{ item.text }}</span>
											</template>
										</v-select>
									</v-row>
								</div>
								<div v-if="key === 'markup'" style="width: 160px">
									<v-row class="font-normal-style font-header-style mx-0 my-1 px-1" style="flex-wrap: nowrap; line-height: 24px" v-for="(markup, index) in item_obj.markup" :key="`${index}_markup`">
										<v-text-field
											v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
											class="field-in-cell font-normal-style"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											style="text-align: end;align-items: end"
											:value="numberFormat(markup)"
											:color="color"
											:disabled="item_obj.mode.value === mode_items[1].value || item_obj.foc === true"
											outlined
											dense
											hide-details
											height="24"
											@change="onChangeMarkup($event, item_obj.index, index)"
										>
											<template v-slot:prepend>
												<v-icon v-if="index === 0" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-currency-usd</v-icon>
												<v-icon v-if="index === 1" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
											</template>
										</v-text-field>
										<v-text-field
											v-if="!ableEdit || !bookingEdit || !item_obj.status.value.includes(planned_value) || item_obj.has_po"
											class="field-in-cell font-normal-style pr-1"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											style="text-align: end;align-items: end"
											:value="numberFormat(markup)"
											:color="color"
											disabled
											background-color="transparent"
											filled
											rounded
											dense
											hide-details
											height="24"
										>
											<template v-slot:prepend>
												<v-icon v-if="index === 0" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-currency-usd</v-icon>
												<v-icon v-if="index === 1" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
											</template>
										</v-text-field>
									</v-row>
								</div>
								<div v-if="key === 'bill'" style="width: 160px">
									<v-row justify="space-between" align="center" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap; line-height: 24px" v-for="(bill, index) in item_obj.bill" :key="`${index}_bill`">
										<span v-if="item_obj.schedule_currency" class="selector-item-style mr-1">{{ item_obj.schedule_currency.code }}&nbsp;</span>
										<v-text-field
											v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
											class="field-in-cell font-normal-style"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											style="text-align: end;align-items: end"
											:value="numberFormat(bill)"
											:color="color"
											:disabled="item_obj.mode.value === mode_items[1].value || item_obj.foc === true"
											outlined
											dense
											hide-details
											height="24"
											@change="onChangeBill($event, item_obj.index)"
										>
										</v-text-field>
										<v-text-field
											v-if="!ableEdit || !bookingEdit || !item_obj.status.value.includes(planned_value) || item_obj.has_po"
											class="field-in-cell font-normal-style pr-1"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											style="text-align: end;align-items: end"
											:value="numberFormat(bill)"
											:color="color"
											disabled
											background-color="transparent"
											filled
											rounded
											dense
											hide-details
											height="24"
										>
										</v-text-field>
									</v-row>
								</div>
								<div v-if="key === 'voucher'" style="width: 56px">
									<v-row justify="center">
										<v-checkbox
											class="mt-0 pt-0"
											v-model="item_obj.voucher"
											:color="color"
											:disabled="!tickableVouch(item_obj) || !ableEdit || !bookingEdit"
											hide-details
											dense
										></v-checkbox>
									</v-row>
								</div>
								<div v-if="key === 'nobill'" style="width: 56px">
									<v-row justify="center">
										<v-checkbox
											class="mt-0 pt-0"
											v-model="item_obj.nobill"
											:color="color"
											:disabled="!tickableDoNoBill(item_obj) || !ableEdit || !bookingEdit"
											hide-details
											dense
										></v-checkbox>
									</v-row>
								</div>
								<div v-if="key === 'revenue'" style="width: 140px">
									<v-row class="font-normal-style font-header-style  mx-0 my-1 px-1" style="flex-wrap: nowrap; line-height: 24px" v-for="(revenue, index) in item_obj.revenue" :key="`${index}_revenue`">
										<v-text-field
											v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
											class="field-in-cell font-normal-style"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											style="text-align: end;align-items: end"
											:value="numberFormat(revenue)"
											:color="color"
											outlined
											dense
											hide-details
											disabled
											height="24"
										>
											<template v-slot:prepend>
												<v-icon small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
											</template>
										</v-text-field>
										<v-text-field
											v-if="!ableEdit || !bookingEdit || !item_obj.status.value.includes(planned_value) || item_obj.has_po"
											class="field-in-cell font-normal-style pr-1"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											style="text-align: end;align-items: end"
											:value="numberFormat(revenue)"
											:color="color"
											background-color="transparent"
											filled
											rounded
											dense
											hide-details
											disabled
											height="24"
										>
											<template v-slot:prepend>
												<v-icon small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
											</template>
										</v-text-field>
									</v-row>
								</div>
								<div v-if="key === 'deadline'" style="width: 180px">
									<v-row class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap;" align="center" v-for="(deadline, index) in item_obj.deadline" :key="`${index}_deadline`">
										<DatePicker
											v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
											style="width: 180px"
											class="date-in-cell"
											:color="color"
											:isOutlined="true"
											:isIcon="true"
											:background="'transparent'"
											:suggestionText="''"
											:persistentHint="false"
											:nudgeLeft="180"
											:dateInit="deadline"
											@date="onChangeDeadLineDate($event, item_obj.index)"
										/>
										<v-row v-else class="ma-0 px-3"  style="flex-wrap: nowrap;" align="center">
											<div v-if="deadline && deadline.length !== 0" style="width: 20px; height: 20px">
												<Calendar :color="'rgba(25, 42, 62, 0.5)'" width="20" height="20"/>
											</div>
											<div class="ml-2 font-normal-style font-header-style" style="min-width: 100px;text-align: start;line-height: 16px">{{ formatDate(deadline) }}</div>
										</v-row>
									</v-row>
								</div>
								<div v-if="key === 'pos_in_break'" style="width: 140px">
									<v-row justify="center" align="center" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap" v-for="(pos, index) in item_obj.pos_in_break" :key="`${index}_pos_in_break`">
										<v-text-field
											v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
											class="font-normal-style font-header-style"
											:color="color"
											v-model="item_obj.pos_in_break[0]"
											outlined
											dense
											hide-details
											height="38"
										>
										</v-text-field>
										<span v-else class="font-normal-style font-header-style">{{ pos }}&nbsp;</span>
									</v-row>
								</div>
								<div v-if="key === 'material_key'" style="width: 140px">
									<v-row justify="center" align="center" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap; line-height: 24px" v-for="(material_key, index) in item_obj.material_key" :key="`${index}_material_key`">
										<v-text-field
											v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
											class="font-normal-style font-header-style"
											:color="color"
											v-model="item_obj.material_key[0]"
											outlined
											dense
											hide-details
											height="38"
										>
										</v-text-field>
										<span v-else class="font-normal-style" :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'">{{ material_key }}&nbsp;</span>
									</v-row>
								</div>
								<div v-if="key === 'priority'" style="width: 140px">
									<v-row justify="center" align="center" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap; line-height: 24px" v-for="(priority, index) in item_obj.priority" :key="`${index}_priority`">
										<v-text-field
											v-if="ableEdit && bookingEdit && item_obj.status.value.includes(planned_value) && !item_obj.has_po"
											class="font-normal-style font-header-style"
											:color="color"
											v-model="item_obj.priority[0]"
											outlined
											dense
											hide-details
											height="38"
										>
										</v-text-field>
										<span v-else class="font-normal-style" :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'">{{ priority }}&nbsp;</span>
									</v-row>
								</div>
								<div v-if="key === 'custom1' && false" style="width: 140px">
									<v-row justify="center" align="center" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap; line-height: 24px" v-for="(custom1, index) in item_obj.custom1" :key="`${index}_custom1`">
										<v-text-field
											v-if="ableEdit && bookingEdit && item_obj.is_edit"
											class="font-normal-style"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											:color="color"
											v-model="item_obj.custom1[0]"
											outlined
											dense
											hide-details
											height="24"
										>
										</v-text-field>
										<span v-else class="font-normal-style" :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'">{{ custom1 }}&nbsp;</span>
									</v-row>
								</div>
								<div v-if="key === 'custom2' && false" style="width: 140px">
									<v-row justify="center" align="center" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap; line-height: 24px" v-for="(custom2, index) in item_obj.custom2" :key="`${index}_custom2`">
										<v-text-field
											v-if="ableEdit && bookingEdit && item_obj.is_edit"
											class="font-normal-style"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											:color="color"
											v-model="item_obj.custom2[0]"
											outlined
											dense
											hide-details
											height="24"
										>
										</v-text-field>
										<span v-else class="font-normal-style" :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'">{{ priority }}&nbsp;</span>
									</v-row>
								</div>
								<div v-if="key === 'custom3' && false" style="width: 140px">
									<v-row justify="center" align="center" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap; line-height: 24px" v-for="(custom3, index) in item_obj.custom3" :key="`${index}_custom3`">
										<v-text-field
											v-if="ableEdit && bookingEdit && item_obj.is_edit"
											class="font-normal-style"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											:color="color"
											v-model="item_obj.custom3[0]"
											outlined
											dense
											hide-details
											height="24"
										>
										</v-text-field>
										<span v-else class="font-normal-style" :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'">{{ custom3 }}&nbsp;</span>
									</v-row>
								</div>
								<div v-if="key === 'custom4' && false" style="width: 140px">
									<v-row justify="center" align="center" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap; line-height: 24px" v-for="(custom4, index) in item_obj.custom4" :key="`${index}_custom4`">
										<v-text-field
											v-if="ableEdit && bookingEdit && item_obj.is_edit"
											class="font-normal-style"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											:color="color"
											v-model="item_obj.custom4[0]"
											outlined
											dense
											hide-details
											height="24"
										>
										</v-text-field>
										<span v-else class="font-normal-style" :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'">{{ custom4 }}&nbsp;</span>
									</v-row>
								</div>
								<div v-if="key === 'custom5' && false" style="width: 140px">
									<v-row justify="center" align="center" class="font-bold-style font-header-style mx-0 my-1 px-2" style="flex-wrap: nowrap; line-height: 24px" v-for="(custom5, index) in item_obj.custom5" :key="`${index}_custom5`">
										<v-text-field
											v-if="ableEdit && bookingEdit && item_obj.is_edit"
											class="font-normal-style"
											:class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'"
											:color="color"
											v-model="item_obj.custom5[0]"
											outlined
											dense
											hide-details
											height="24"
										>
										</v-text-field>
										<span v-else class="font-normal-style" :class="item_obj.status.value.includes(reversal_value) ? 'reversal-text-color':'font-header-style'">{{ custom5 }}&nbsp;</span>
									</v-row>
								</div>							
							</td>
						</tr>
						<tr style="height: 48px; background-color: #D0D0D5;">
							<td colspan="6" style="border-right: thin solid rgba(0, 0, 0, 0.12)">
								<v-row class="ma-0 pr-4 font-bold-style font-header-style" justify="end">Total</v-row>
							</td>
							<td v-for="(item, key) in totalValue" :key="key">
								<span v-if="item.length === 0">{{ item }}&nbsp;</span>
								<v-row v-if="item.length !== 0" class="ma-0 pl-2 pr-5" justify="space-between" align="center">
									<div class="font-bold-style selector-item-style">{{ (item.split(link_icon))[0] }}</div>
									<div class="font-bold-style font-header-style">{{ (item.split(link_icon))[1] }}</div>
								</v-row>
							</td>
						</tr>
					</template>
				</tbody>
			</template>
		</v-data-table>
		<HistoryDialog
			v-if="history_visible"
			:visible="history_visible"
			:refId="history_ref_id"
			@input="history_visible = $event"
		/>
	</div>
</template>

<script>
import Calendar from "@/components/icons/calendar.vue";
import Delete from "@/components/icons/delete_outline.vue";
import DatePicker from "@/components/date/date_picker.vue";
import HistoryDialog from "@/views/desktop/media/radio_holdings/media_holding_history_dialog";

import moment from 'moment';
import Decimal from 'decimal.js';

const Planned_Color = '#8C7503';
const Unapproved_Color = '#D5A39B';
const Booked_Color = '#C35643';
const Test_Invoice_Color = '#9DB475';
const Invoiced_Color = '#547F0A';
const Credit_Note_Color = '#2C4108';
const Reversal_Color = '#A79C9C';
const Reversed_Color = '#726A6A';

const Status_Items = [
	{ text: 'Planned', key: 'planned', value: [1], color: Planned_Color, delete: true, last: false },
	{ text: 'Booked', key: 'booked', value: [2], color: Booked_Color, delete: false, last: false },
	{ text: 'Test Invoice', key: 'test_invoice', value: [3], color: Test_Invoice_Color, delete: false, last: false },
	{ text: 'Invoiced', key: 'invoiced', value: [4], color: Invoiced_Color, delete: false, last: false },
	{ text: 'Test Credit Note', key: 'note', value: [5], color: Credit_Note_Color, delete: false, last: false },
	{ text: 'Unapproved PO', key: 'unapproved', value: [6], color: Unapproved_Color, delete: false, last: false },
	{ text: 'Reversed', key: 'reversed', value: [100], color: Reversed_Color, delete: true, last: false },
	{ text: 'Reversal', key: 'reversal', value: [101], color: Reversal_Color, delete: true, last: false },
];

const Reversed_Value = 100;
const Reversal_Value = 101;
const Planned_Value = 1;
const Unapproved_Value = 6;

const Mode_Items = [
	{ text: 'Markup', value: 0 },
	{ text: 'Commission', value: 1 },
	{ text: 'Rebate', value: 2 },
	{ text: 'Mkup+Comm', value: 3 }
];
const Week_day = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
const Decimal_Places = 5;
const Link_Icon = '_';

const Header = [
	{
		text: ['Station', 'Program Name'],
		sortable: false,
		align: 'center',
		value: 'booking_station',
		width: 180
	},
	{
		text: ['Media Reference ID', ''],
		sortable: false,
		align: 'center',
		value: 'reference',
		width: 200
	},
	{
		text: ['Start time', 'Duration'],
		sortable: false,
		align: 'center',
		value: 'duration',
		width: 120
	},
	{
		text: ['End time', ''],
		sortable: false,
		align: 'center',
		value: 'time',
		width: 120
	},
	{
		text: ['Booked Date', 'Booked Day Flags'],
		sortable: false,
		align: 'center',
		value: 'date',
		width: 180
	},
	{
		text: ['Status', ''],
		sortable: false,
		divider: true,
		align: 'center',
		value: 'status',
		width: 200
	},
	{
		text: ['Cost Currency', 'Exchange rate'],
		sortable: false,
		align: 'center',
		value: 'cost',
		width: 180
	},
	{
		text: ['Supplier rate ($)', 'Supplier Amount ($)'],
		sortable: false,
		align: 'center',
		value: 'supplier',
		width: 180
	},
	{
		text: ['Commission ($)', 'Commission (%)'],
		sortable: false,
		align: 'center',
		value: 'commission',
		width: 160
	},
	{
		text: ['Schedule Currency', 'Exchange rate'],
		sortable: false,
		align: 'center',
		value: 'schedule',
		width: 180
	},
	{
		text: ['Net ($)', ''],
		sortable: false,
		align: 'center',
		value: 'net',
		width: 180
	},
	{
		text: ['FOC', ''],
		sortable: false,
		align: 'center',
		value: 'foc',
		width: 100
	},
	{
		text: ['Mode', ''],
		sortable: false,
		align: 'center',
		value: 'mode',
		width: 180
	},
	{
		text: ['Mark up / Rebate ($)', 'Mark up / Rebate (%)'],
		sortable: false,
		align: 'center',
		value: 'markup',
		width: 180
	},
	{
		text: ['Bill to client ($)', ''],
		sortable: false,
		align: 'center',
		value: 'bill',
		width: 180
	},
	{
		text: ['Vouchered', ''],
		sortable: false,
		align: 'center',
		value: 'voucher',
		width: 100
	},
	{
		text: ['Do not bill', ''],
		sortable: false,
		align: 'center',
		value: 'nobill',
		width: 100
	},
	{
		text: ['Revenue (%)', ''],
		sortable: false,
		divider: true,
		align: 'center',
		value: 'revenue',
		width: 160
	},
	{
		text: ['Material Deadline', ''],
		sortable: false,
		align: 'center',
		value: 'deadline',
		width: 180
	},
	{
		text: ['Position in Break', ''],
		sortable: false,
		align: 'center',
		value: 'pos_in_break',
		width: 180
	},
	{
		text: ['Material Key Number', ''],
		sortable: false,
		align: 'center',
		value: 'material_key',
		width: 180
	},
	{
		text: ['Priority Modifier', ''],
		sortable: false,
		align: 'center',
		value: 'priority',
		width: 180
	},
	// {
	// 	text: ['Custom 1', ''],
	// 	sortable: false,
	// 	align: 'center',
	// 	value: 'custom1',
	// 	width: 180
	// },
	// {
	// 	text: ['Custom 2', ''],
	// 	sortable: false,
	// 	align: 'center',
	// 	value: 'custom2',
	// 	width: 180
	// },
	// {
	// 	text: ['Custom 3', ''],
	// 	sortable: false,
	// 	align: 'center',
	// 	value: 'custom3',
	// 	width: 180
	// },
	// {
	// 	text: ['Custom 4', ''],
	// 	sortable: false,
	// 	align: 'center',
	// 	value: 'custom4',
	// 	width: 180
	// },
	// {
	// 	text: ['Custom 5', ''],
	// 	sortable: false,
	// 	align: 'center',
	// 	value: 'custom5',
	// 	width: 180
	// }
];
const Middle_Header = [
	'cost',
	'supplier',
	'commission',
	'schedule',
	'net',
	'voucher',
	'nobill',
	'foc',
	'mode',
	'markup',
	'bill',
	'margin',
	'revenue'
];

export default {
	name: 'MediaRadioTable',
	props: {
		color: {
			type: String,
			default: '',
		},
		mediaId: {
			type: Number,
			default: 0
		},
		supplier: {
			type: Object,
			default: null
		},
		kind: {
			type: Object,
			default: null
		},
		markupPerc: {
			type: Number,
			default: 0
		},
		rebatePerc: {
			type: Number,
			default: 0
		},
		exchangeRate: {
			type: String,
			default: '0.00',
		},
		costRate: {
			type: Object,
			default: null
		},
		scheduleRate: {
			type: Object,
			default: null
		},
		costCurrency: {
			type: Object,
			default: null
		},
		scheduleCurrency: {
			type: Object,
			default: null
		},
		ableEdit: {
			type: Boolean,
			default: false
		},
		ableDelete: {
			type: Boolean,
			default: true
		},
		ableStatus: {
			type: Boolean,
			default: true
		},
		ableInv: {
			type: Boolean,
			default: true
		},
		bookingEdit: {
			type: Boolean,
			default: true
		},
		radioList: {
			type: Array,
			default: () => []
		}
	},
	data() {
		this.mode_items = Mode_Items;
		this.reversal_value = Reversal_Value;
		this.reversed_value = Reversed_Value;
		this.planned_value = Planned_Value;
		this.middle_header = Middle_Header;
		this.link_icon = Link_Icon;
		this.weekday = Week_day;

		return {
			headers: Header,

			radio_list: [],
			radio_list_original: [],

			history_visible: false,
			history_ref_id: ''
		}
	},
	components: {
		Calendar,
		Delete,
		DatePicker,
		HistoryDialog
	},
	created() {
		if (this.radioList.length !== 0) {
			this.getRadioList(this.radioList);
		}
	},
	computed: {
		totalValue() {
			const total_value_item = {
				cost: '',
				supplier: '',
				commission: '',	
				schedule: '',
				net: '',
				foc: '',
				mode: '',
				markup: '',
				bill: '',
				voucher: '',
				nobill: '',
				revenue: '',
				deadline: '',
				pos_in_break: '',
				material_key: '',
				priority: ''
			};

			if (this.radio_list.length !== 0) {
				/** Supplier Amount */
				const supplier_arr = this.radio_list.map(list => { return Number(list.supplier[1]) });
				const supplier_fc_total = supplier_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
				const formatted_supplier_fc = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(supplier_fc_total);
				total_value_item['supplier'] = `${this.costCurrency.code}${Link_Icon}${formatted_supplier_fc}`;

				/** Commission Amount */
				const commission_arr = this.radio_list.map(list => { return Number(list.commission[0]) });
				const commission_fc_total = commission_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
				const formatted_commission_fc = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(commission_fc_total);
				total_value_item['commission'] = `${this.costCurrency.code}${Link_Icon}${formatted_commission_fc}`;

				/** Net -> netamount */
				const net_arr = this.radio_list.map(list => { return Number(list.net[0]) });
				const net_fc_total = net_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
				const formatted_net_fc = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(net_fc_total);
				total_value_item['net'] = `${this.scheduleCurrency.code}${Link_Icon}${formatted_net_fc}`;


				/** Markup */
				const markup_arr = this.radio_list.map(list => { return Number(list.markup[0]) });
				const markup_fc_total = markup_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
				const formatted_markup_fc = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(markup_fc_total);
				total_value_item['markup'] = `${this.scheduleCurrency.code}${Link_Icon}${formatted_markup_fc}`;


				/** Bill */
				const bill_arr = this.radio_list.map(list => { return Number(list.bill[0]) });
				const bill_fc_total = bill_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
				const formatted_bill_fc = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(bill_fc_total);
				total_value_item['bill'] = `${this.scheduleCurrency.code}${Link_Icon}${formatted_bill_fc}`;
			}

			return total_value_item;
		},
	},
	watch: {
		radioList() {
			this.getRadioList(this.radioList);
		},
		supplier() {
			if (this.radio_list.length !== 0 && this.supplier) {
				this.radio_list.forEach(b => {
					if (b.status_id === Planned_Value && !b.rev_id ) {
						b.commission[1] = Number(this.supplier.commission_perc).toFixed(2);
						b.cost_currency =this.supplier.currency;
						
						if (this.rebatePerc !== 0) {
							b.mode = Mode_Items[2];
							b.markup[1] = Number(this.rebatePerc).toFixed(2);
						} else {
							/** if commission_perc = 0, mode => markup */
							if (Number(this.supplier.commission_perc) === 0) {
								b.mode = Mode_Items[0];
								b.markup[1] = Number(this.markupPerc).toFixed(2);
							} else {
								b.mode = Mode_Items[1];
								b.markup[1] = '0.00';
							}
						}

						const booking_new = this._calculateBookingAmount(b, false);
						for (const [key] of Object.entries(b)) {
							b[`${key}`] = booking_new[`${key}`]
						}
					}
				});

				this.radio_list_original.forEach(b => { 
					if (b.status_id === Planned_Value && !b.rev_id ) {
						b.commission[1] = Number(this.supplier.commission_perc).toFixed(2);
						b.cost_currency = this.supplier.currency;
						
						if (this.rebatePerc !== 0) {
							b.mode = Mode_Items[2];
							b.markup[1] = Number(this.rebatePerc).toFixed(2);
						} else {
							/** if commission_perc = 0, mode => markup */
							if (Number(this.supplier.commission_perc) === 0) {
								b.mode = Mode_Items[0];
								b.markup[1] = Number(this.markupPerc).toFixed(2);
							} else {
								b.mode = Mode_Items[1];
								b.markup[1] = '0.00';
							}
						}

						const booking_new = this._calculateBookingAmount(b, false);
						for (const [key] of Object.entries(b)) {
							b[`${key}`] = booking_new[`${key}`]
						}
					}
				});
			}
		},
		markupPerc() {
			if (this.radio_list.length !== 0 && this.supplier) {
				this.radio_list.forEach(b => {
					if (b.status_id === Planned_Value && !b.rev_id ) {
						if (this.rebatePerc !== 0) {
							b.mode = Mode_Items[2];
							b.markup[1] = Number(this.rebatePerc).toFixed(2);
						} else {
							/** if commission_perc = 0, mode => markup */
							if (Number(this.supplier.commission_perc) === 0) {
								b.mode = Mode_Items[0];
								b.markup[1] = Number(this.markupPerc).toFixed(2);
							} else {
								b.mode = Mode_Items[1];
								b.markup[1] = '0.00';
							}
						}

						const booking_new = this._calculateBookingAmount(b, false);
						for (const [key] of Object.entries(b)) {
							b[`${key}`] = booking_new[`${key}`]
						}
					}
				});

				this.radio_list_original.forEach(b => { 
					if (b.status_id === Planned_Value && !b.rev_id ) {
						if (this.rebatePerc !== 0) {
							b.mode = Mode_Items[2];
							b.markup[1] = Number(this.rebatePerc).toFixed(2);
						} else {
							/** if commission_perc = 0, mode => markup */
							if (Number(this.supplier.commission_perc) === 0) {
								b.mode = Mode_Items[0];
								b.markup[1] = Number(this.markupPerc).toFixed(2);
							} else {
								b.mode = Mode_Items[1];
								b.markup[1] = '0.00';
							}
						}

						const booking_new = this._calculateBookingAmount(b, false);
						for (const [key] of Object.entries(b)) {
							b[`${key}`] = booking_new[`${key}`]
						}
					}
				});
			}
		},
		rebatePerc() {
			if (this.radio_list.length !== 0 && this.supplier) {
				this.radio_list.forEach(b => {
					if (b.status_id === Planned_Value && !b.rev_id ) {
						if (this.rebatePerc !== 0) {
							b.mode = Mode_Items[2];
							b.markup[1] = Number(this.rebatePerc).toFixed(2);
						} else {
							/** if commission_perc = 0, mode => markup */
							if (Number(this.supplier.commission_perc) === 0) {
								b.mode = Mode_Items[0];
								b.markup[1] = Number(this.markupPerc).toFixed(2);
							} else {
								b.mode = Mode_Items[1];
								b.markup[1] = '0.00';
							}
						}

						const booking_new = this._calculateBookingAmount(b, false);
						for (const [key] of Object.entries(b)) {
							b[`${key}`] = booking_new[`${key}`]
						}
					}
				});

				this.radio_list_original.forEach(b => { 
					if (b.status_id === Planned_Value && !b.rev_id ) {
						if (this.rebatePerc !== 0) {
							b.mode = Mode_Items[2];
							b.markup[1] = Number(this.rebatePerc).toFixed(2);
						} else {
							/** if commission_perc = 0, mode => markup */
							if (Number(this.supplier.commission_perc) === 0) {
								b.mode = Mode_Items[0];
								b.markup[1] = Number(this.markupPerc).toFixed(2);
							} else {
								b.mode = Mode_Items[1];
								b.markup[1] = '0.00';
							}
						}

						const booking_new = this._calculateBookingAmount(b, false);
						for (const [key] of Object.entries(b)) {
							b[`${key}`] = booking_new[`${key}`]
						}
					}
				});
			}
		},
		costCurrency(newVal, oldVal) {
			if (newVal && oldVal && newVal.id !== oldVal.id) {
				if (this.radio_list.length !== 0) {
					this.radio_list.forEach(b => {
						if (b.status_id === Planned_Value && !b.rev_id ) {
							b.cost_currency = newVal;
						}
					});

					this.radio_list_original.forEach(b => { 
						if (b.status_id === Planned_Value && !b.rev_id ) {
							b.cost_currency = newVal;
						}
					});
				}
			}
		},
		scheduleCurrency(newVal, oldVal) {
			if (newVal && oldVal && newVal.id !== oldVal.id) {
				if (this.radio_list.length !== 0) {
					this.radio_list.forEach(b => {
						if (b.status_id === Planned_Value && !b.rev_id ) {
							b.schedule_currency = newVal;
						}
					});

					this.radio_list_original.forEach(b => { 
						if (b.status_id === Planned_Value && !b.rev_id ) {
							b.schedule_currency = newVal;
						}
					});
				}
			}
		},
		costRate(newVal, oldVal) {
			if (newVal && oldVal && newVal.rate !== oldVal.rate) {
				if (this.radio_list.length !== 0) {
					this.radio_list.forEach(b => {
						if (b.status_id === Planned_Value && !b.rev_id ) {
							b.cost = [Number(newVal.rate).toFixed(Decimal_Places)];

							const booking_new = this._calculateBookingAmount(b, false);
							for (const [key] of Object.entries(b)) {
								b[`${key}`] = booking_new[`${key}`]
							}
						}
					});

					this.radio_list_original.forEach(b => { 
						if (b.status_id === Planned_Value && !b.rev_id ) {
							b.cost = [Number(newVal.rate).toFixed(Decimal_Places)];

							const booking_new = this._calculateBookingAmount(b, false);
							for (const [key] of Object.entries(b)) {
								b[`${key}`] = booking_new[`${key}`]
							}
						}
					});
				}
			}
		},
		scheduleRate(newVal, oldVal) {
			if (newVal && oldVal && newVal.rate !== oldVal.rate) {
				if (this.radio_list.length !== 0) {
					this.radio_list.forEach(b => {
						if (b.status_id === Planned_Value && !b.rev_id ) {
							b.schedule = [Number(newVal.rate).toFixed(Decimal_Places)];

							const booking_new = this._calculateBookingAmount(b, false);
							for (const [key] of Object.entries(b)) {
								b[`${key}`] = booking_new[`${key}`]
							}
						}
					});

					this.radio_list_original.forEach(b => { 
						if (b.status_id === Planned_Value && !b.rev_id ) {
							b.schedule = [Number(newVal.rate).toFixed(Decimal_Places)];

							const booking_new = this._calculateBookingAmount(b, false);
							for (const [key] of Object.entries(b)) {
								b[`${key}`] = booking_new[`${key}`]
							}
						}
					});
				}
			}
		},
		exchangeRate(newVal, oldVal) {
			if (Number(newVal) !== Number(oldVal)) {
				if (this.radio_list.length !== 0) {
					this.radio_list.forEach(b => {
						if (b.status_id === Planned_Value && !b.rev_id ) {
							b.margin = [newVal];

							const booking_new = this._calculateBookingAmount(b, false);
							for (const [key] of Object.entries(b)) {
								b[`${key}`] = booking_new[`${key}`]
							}
						}
					});

					this.radio_list_original.forEach(b => { 
						if (b.status_id === Planned_Value && !b.rev_id ) {
							b.margin = [newVal];

							const booking_new = this._calculateBookingAmount(b, false);
							for (const [key] of Object.entries(b)) {
								b[`${key}`] = booking_new[`${key}`]
							}
						}
					});
				}
			}
		},
		radio_list: {
			deep: true,
			handler() {
				this.$emit('radio', this.radio_list)
			}
		}
	},
	methods: {
		getRadioList(holdings) {
			this.radio_list = [];
			this.radio_list_original = [];

			holdings.forEach(holding => {
				holding.booking_start = this.calculateBookedDate(holding.booked_date, holding.booking_day_flags);
				holding.booking_end = this.calculateBookedEnd(holding.booked_date, holding.booking_day_flags);
			});

			const reversal_filter = holdings.filter(d => { return d.rev_id !== null && d.rev_id > 1 });
			const normal_filter = holdings.filter(d => { return d.rev_id === null || d.rev_id === 1 });

			normal_filter.sort((a,b) => { 
				if (a.booking_start !== b.booking_start) {
					return a.booking_start - b.booking_start;
				} else {
					const a_rev_id = a.rev_id === null ? 0 : a.rev_id;
					const b_rev_id = b.rev_id === null ? 0 : b.rev_id;
					if (a_rev_id !== b_rev_id) {
						return b_rev_id - a_rev_id;
					} else {
						return a.id - b.id;
					}
				}
			});

			const reversed_filter = normal_filter.filter(normal => { return normal.rev_id !== null && normal.rev_id === 1 });
			for (let index = 0; index < reversed_filter.length; index++) {
				const reversed = reversed_filter[index];
				const reversed_index = normal_filter.findIndex(normal => normal.id === reversed.id );
				const insert_element = reversal_filter.filter(reversal => { return reversal.rev_id === reversed.id } );
				normal_filter.splice(reversed_index + 1, 0 , insert_element[0])
			}

			normal_filter.forEach(b => {
				let status_filter_arr = [];
				if (b.rev_id && b.rev_id === 1) {
					status_filter_arr = Status_Items.filter(s => { return s.value.includes(Reversed_Value) });
				} else if (b.rev_id && b.rev_id > 1) {
					status_filter_arr = Status_Items.filter(s => { return s.value.includes(Reversal_Value) });
				} else {
					if (b.status === Planned_Value && b.has_po === true) {
						status_filter_arr = Status_Items.filter(s => { return s.value.includes(Unapproved_Value) });
					} else {
						status_filter_arr = Status_Items.filter(s => { return s.value.includes(b.status) });
					}
				}	

				const holding_item = {
					booking_station: b.station ? [b.station, b.program_name] : ['', b.program_name],
					reference: [b.media_reference_id],
					duration: [`${b.booking_start_time.substring(0,2)}:${b.booking_start_time.substring(2,4)}`, `${b.booking_duration} sec`],
					time: [`${b.booking_end_time.substring(0,2)}:${b.booking_end_time.substring(2,4)}`, ''],
					date: [moment(b.booking_start).format('YYYY-MM-DD'), b.booking_day_flags],
					status: status_filter_arr[0],
					cost: [Number(b.exrate_cost).toFixed(Decimal_Places)],
					supplier: [Number(b.rate_fc).toFixed(2), Number(b.amount_fc).toFixed(2)],
					commission: [Number(b.commamount_fc).toFixed(2),  Number(b.comm_perc).toFixed(2)],
					schedule: [Number(b.exrate_value).toFixed(Decimal_Places)],
					net: [Number(b.net_fc).toFixed(2)],
					foc: b.is_foc,
					mode: (Mode_Items.filter(mode => { return mode.value === b.booking_mode }))[0],
					markup: [Number(b.markupamount_fc).toFixed(2) , Number(b.markup_perc).toFixed(2)],
					bill: [Number(b.value_fc).toFixed(2)],
					voucher: b.is_vouchered,
					nobill: b.donotbill,
					revenue: [Number(b.revenue_perc).toFixed(2)],
					margin: [this.exchangeRate],
					is_deleted: b.is_deleted,
					is_edit: b.status <= Planned_Value && b.has_po === false && b.has_cinv === false,
					status_id: b.status,
					status_original_id: b.status,
					cost_currency: this.costCurrency,
					schedule_currency: this.scheduleCurrency,
					deadline: b.material_deadline && b.material_deadline.length !== 0 ? [moment(b.material_deadline).format('YYYY-MM-DD')] : [''],
					pos_in_break: [`${b.pos_in_break}`],
					material_key: [`${b.material_key_identifier}`],
					priority: [`${b.priority_modifier}`],
					// custom1: [''],
					// custom2: [''],
					// custom3: [''],
					// custom4: [''],
					// custom5: [''],
					has_po: b.has_po,
					has_cinv: b.has_cinv,
					id: b.id,
					index: `0_${b.id}`,
					is_total: false,
					rev_id: b.rev_id,
					med_ref_id: b.media_reference_id,
					booking_day_flags: b.booking_day_flags,
					booking_start_time: b.booking_start_time,
					booking_end_time: b.booking_end_time,
					prog_name: b.program_name,
					contract_ref: b.contract_ref,
					network_code: b.network_code,
					booking_duration: b.booking_duration,
					booking_start: b.booking_start,
					booking_end: b.booking_end,
					booked_date: b.booked_date,
					station: b.station,
					units: 1
				};

				this.radio_list.push(holding_item);
				this.radio_list_original.push(holding_item);
			});
		},
		filterItem(item_obj) {
			let filter_obj = {};

			const header_value_arr = this.headers.map(header => { return header.value });
			header_value_arr.forEach(header => { 
				filter_obj[`${header}`] = item_obj[`${header}`];
			});

			return filter_obj;
		},
		numberFormat(num_str) {
			let number_format = '';

			if (typeof(num_str) === 'string' && num_str.length !== 0) {
				number_format = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(num_str);
			}
			return number_format;
		},
		formatDate(date) {
			let date_tmp = '';

			if (typeof(date) === 'string' && date.length !== 0) {
				date_tmp = moment(date).format('DD MMM YYYY')
			}

			return date_tmp;
		},
		filterStatus(status_id) {
			let status_list = [];

			const status_items_copy = JSON.parse(JSON.stringify(Status_Items));

			if (status_id !== 0) {
				/** planned */
				if (status_id === 1) {
					status_list = status_items_copy.filter(item => { return item.key === 'booked' || item.key === 'planned'});
				}
				/** booked */
				if (status_id === 2) {
					status_list = status_items_copy.filter(item => { return item.key === 'planned' || item.key === 'invoiced' || item.key === 'booked'});
				}
				/** test_invoice */
				if (status_id === 3) {
					status_list = status_items_copy.filter(item => { return item.key === 'planned' || item.key === 'invoiced' || item.key === 'booked' || item.key === 'test_invoice'});
				}
				/** invoiced */
				if (status_id === 4) {
					status_list = status_items_copy.filter(item => { return item.key === 'planned' || item.key === 'invoiced' || item.key === 'booked' });
				}
				/** note */
				if (status_id === 5) {
					status_list = status_items_copy.filter(item => { return item.key === 'planned' || item.key === 'invoiced' || item.key === 'booked' || item.key === 'note' });
				}
				
				status_list[status_list.length - 1].last = true;
			}

			return status_list;
		},
		onHistoryClick(item) {
			this.history_ref_id = item;
			this.history_visible = true;
		},
		onStatusChange(status, radio) {
			this.radio_list.forEach(r => {
				if (r.id === radio.id) {
					r['status_id'] = status.value[0];
				}
			});

			this.radio_list_original.forEach(r => {
				if (r.id === radio.id) {
					r['status_id'] = status.value[0];
				}
			});
		},
		onDeleteBooking(item) {
			this.radio_list = this.radio_list.filter(r => { return r.index !== item.index });
			this.radio_list_original = this.radio_list_original.filter(r => { return r.index !== item.index });
		},
		onReverseBooking(item) {
			const status_reversed_arr = Status_Items.filter(s => { return s.value.includes(Reversed_Value) });
			item['status'] = status_reversed_arr[0];
			item['rev_id'] = 1;
			if (!item.has_cinv) {
				item['nobill'] = true;
			}

			/** create a reversal booking line automatically */
			const reversal_item = JSON.parse(JSON.stringify(item));
			reversal_item['id'] = 0;
			reversal_item['index'] = this._getNewIndex();
			reversal_item['rev_id'] = item.id;
			if (!reversal_item.has_cinv) {
				reversal_item['nobill'] = true;
			}

			const status_reversal_arr = Status_Items.filter(s => { return s.value.includes(Reversal_Value) });
			reversal_item['status'] = status_reversal_arr[0];

			const supplier_rate = Number(reversal_item.supplier[0]) === 0 ? Number(reversal_item.supplier[0]) : -Number(reversal_item.supplier[0]);
			const supp_amount = Number(reversal_item.supplier[1]) === 0 ? Number(reversal_item.supplier[1]) : -Number(reversal_item.supplier[1]);
			reversal_item['supplier'] = [Number(supplier_rate).toFixed(2), Number(supp_amount).toFixed(2)];
			
			const commission_amount = Number(reversal_item.commission[0]) === 0 ? Number(reversal_item.commission[0]) : -Number(reversal_item.commission[0]);
			reversal_item['commission'] = [Number(commission_amount).toFixed(2), reversal_item.commission[1]];
			
			const net = Number(reversal_item.net[0]) === 0 ? Number(reversal_item.net[0]) : -Number(reversal_item.net[0]);
			reversal_item['net'] = [Number(net).toFixed(2)];

			const markup = Number(reversal_item.markup[0]) === 0 ? Number(reversal_item.markup[0]) : -Number(reversal_item.markup[0]);
			reversal_item['markup'] = [Number(markup).toFixed(2), reversal_item.markup[1]];

			const bill = Number(reversal_item.bill[0]) === 0 ? Number(reversal_item.bill[0]) : -Number(reversal_item.bill[0]);
			reversal_item['bill'] = [Number(bill).toFixed(2)];

			/** create a new booking line automatically */
			const reversal_item_plan = JSON.parse(JSON.stringify(item));
			reversal_item_plan['id'] = 0;
			reversal_item_plan['index'] = this._getNewIndex() + 1;
			reversal_item_plan['rev_id'] = null;
			reversal_item_plan['status_id'] = Planned_Value;
			reversal_item_plan['status_original_id'] = Planned_Value;
			reversal_item_plan['nobill'] = false;
			reversal_item_plan['has_po'] = false;
			reversal_item_plan['has_cinv'] = false;

			const status_plan_arr = Status_Items.filter(s => { return s.value.includes(Planned_Value) });
			reversal_item_plan['status'] = status_plan_arr[0];

			const insert_index = this.radio_list.findIndex(radio => { return radio.id === item.id });
			this.radio_list.splice(insert_index + 1, 0, reversal_item, reversal_item_plan);
			this.radio_list_original.splice(insert_index + 1, 0, reversal_item, reversal_item_plan);
		},
		onChangeSupplier(supplier, item_index) {
			let number_parse = '';
			if (supplier.includes(',')) {
				const numberString = supplier.replace(/[^0-9.-]+/g, "");
				number_parse = Number(numberString).toFixed(2);
			} else {
				number_parse = Number(supplier).toFixed(2);
			}

			const booking_item = this.radio_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.supplier[0] = number_parse;
			const booking_new = this._calculateBookingAmount(new_booking_item, false);

			this.radio_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});

			this.radio_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});
		},
		onChangeCommission(commission, item_index, index) {
			let number_parse = '';
			if (commission.includes(',')) {
				const numberString = commission.replace(/[^0-9.-]+/g, "");
				number_parse = Number(numberString).toFixed(2);
			} else {
				number_parse = Number(commission).toFixed(2);
			}

			const booking_item = this.radio_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.commission[`${index}`] = number_parse;

			const is_commission_amount = index === 0 ? true : false;
			const booking_new = this._calculateBookingAmount(new_booking_item, is_commission_amount);

			this.radio_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});

			this.radio_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});
		},
		onChangeNet(net, item_index) {
			let number_parse = '';
			if (net.includes(',')) {
				const numberString = net.replace(/[^0-9.-]+/g, "");
				number_parse = Number(numberString).toFixed(2);
			} else {
				number_parse = Number(net).toFixed(2);
			}

			const booking_item = this.radio_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.net = [number_parse];
			const booking_new = this._calculateBookingNet(new_booking_item);

			this.radio_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});

			this.radio_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});
		},
		onChangeFOC(foc, item_index) {
			const booking_item = this.radio_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.foc = foc;
			const booking_new = this._calculateBookingFOC(new_booking_item);

			this.radio_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});

			this.radio_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});
		},
		onChangeMode(mode, item_index) {
			const booking_item = this.radio_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.mode = mode;
			const booking_new = this._calculateBookingMode(new_booking_item);

			this.radio_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});

			this.radio_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});
		},
		onChangeMarkup(markup, item_index, index) {
			let number_parse = '';
			if (markup.includes(',')) {
				const numberString = markup.replace(/[^0-9.-]+/g, "");
				number_parse = Number(numberString).toFixed(2);
			} else {
				number_parse = Number(markup).toFixed(2);
			}

			const booking_item = this.radio_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.markup[`${index}`] = number_parse;
			const booking_new = this._calculateBaseMode(new_booking_item, index === 0 ? true : false, index === 1 ? true : false, false);

			this.radio_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});

			this.radio_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});
		},
		onChangeBill(bill, item_index) {
			let number_parse = '';
			if (bill.includes(',')) {
				const numberString = bill.replace(/[^0-9.-]+/g, "");
				number_parse = Number(numberString).toFixed(2);
			} else {
				number_parse = Number(bill).toFixed(2);
			}

			const booking_item = this.radio_list.find(b => { return b.index === item_index });
			const new_booking_item = JSON.parse(JSON.stringify(booking_item));
			new_booking_item.bill = [number_parse];
			const booking_new = this._calculateBaseMode(new_booking_item, false, false, true);

			this.radio_list.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});

			this.radio_list_original.forEach(b => {
				if (b.index === item_index) {
					for (const [key] of Object.entries(b)) {
						b[`${key}`] = booking_new[`${key}`]
					}
				}
			});
		},
		onChangeDeadLineDate(date, item_index) {
			this.error_msg = '';

			if (date && date.length !== 0) {
				this.radio_list.forEach(b => {
					if (b.index === item_index) {
						b.deadline = [date];
					}
				});

				this.radio_list_original.forEach(b => {
					if (b.index === item_index) {
						b.deadline = [date];
					}
				});
			} else {
				this.radio_list.forEach(b => {
					if (b.index === item_index) {
						b.deadline = [''];
					}
				});

				this.radio_list_original.forEach(b => {
					if (b.index === item_index) {
						b.deadline = [''];
					}
				});
			}
		},
		calculateBookedDate(booked_date, day_flags) {
			let booking_start = '';

			if (booked_date && day_flags && booked_date.length !== 0 && day_flags.length !== 0) {
				const start_date = moment(booked_date);

				let normalized_day_flags = typeof day_flags === 'string' ? day_flags : day_flags.join('');
				if (normalized_day_flags.length === 6) {
					normalized_day_flags = `${normalized_day_flags}0`;
				}

				if (start_date.isValid() && normalized_day_flags.length === 7) {
					for (let offset = 0; offset < 7; offset++) {
						const current_date = start_date.clone().add(offset, 'days');

						if (normalized_day_flags[current_date.day()] === '1') {
							booking_start = current_date.format('YYYY-MM-DD');
							break;
						}
					}
				}
			}

			return booking_start;
		},
		calculateBookedEnd(booked_date, day_flags) {
			let booking_end = '';

			if (booked_date && day_flags && booked_date.length !== 0 && day_flags.length !== 0) {
				const start_date = moment(booked_date);

				let normalized_day_flags = typeof day_flags === 'string' ? day_flags : day_flags.join('');
				if (normalized_day_flags.length === 6) {
					normalized_day_flags = `${normalized_day_flags}0`;
				}

				if (start_date.isValid() && normalized_day_flags.length === 7) {
					for (let offset = 0; offset < 7; offset++) {
						const current_date = start_date.clone().add(offset, 'days');

						if (normalized_day_flags[current_date.day()] === '1') {
							booking_end = current_date.format('YYYY-MM-DD');
						}
					}
				}
			}

			return booking_end;
		},
		tickableVouch(booking) {
			let is_able = true;

			if (booking.rev_id && booking.rev_id === Planned_Value) {
				/** Reversed */
				is_able = false;
			}

			if (booking.rev_id && booking.rev_id > Planned_Value) {
				/** Reversal */
				is_able = false;
			}
			
			return is_able
		},
		tickableFOC(booking) {
			let is_able = true;

			if (booking.status_id === Planned_Value && !booking.rev_id) {
				/** Planned */
				if (booking.has_po) {
					is_able = false;
				} else {
					is_able = true;
				}
			}

			const booked_filter = Status_Items.filter(s => { return s.key === 'booked'});
			if (booked_filter[0].value.includes(booking.status_id)) {
				/** Booked */
				is_able = false;
			}

			const test_invoice_filter = Status_Items.filter(s => { return s.key === 'test_invoice'});
			if (test_invoice_filter[0].value.includes(booking.status_id)) {
				/** Test Invoice */
				is_able = false;
			}

			const invoiced_filter = Status_Items.filter(s => { return s.key === 'invoiced'});
			if (invoiced_filter[0].value.includes(booking.status_id)) {
				/** Invoiced */
				is_able = false;
			}

			const note_filter = Status_Items.filter(s => { return s.key === 'note'});
			if (note_filter[0].value.includes(booking.status_id)) {
				/** Test Credit Note */
				is_able = false;
			}

			if (booking.rev_id && booking.rev_id === Planned_Value) {
				/** Reversed */
				is_able = false;
			}

			if (booking.rev_id && booking.rev_id > Planned_Value) {
				/** Reversal */
				is_able = false;
			}

			return is_able;
		},
		tickableDoNoBill(booking) {
			let is_able = true;

			if (booking.status_id === Planned_Value && !booking.rev_id) {
				/** Planned */
				if (booking.has_po) {
					is_able = false;
				} else {
					is_able = true;
				}
			}

			const booked_filter = Status_Items.filter(s => { return s.key === 'booked'});
			if (booked_filter[0].value.includes(booking.status_id)) {
				/** Booked */
				if (booking.has_cinv) {
					is_able = false;
				} else {
					is_able = true;
				}
			}

			const test_invoice_filter = Status_Items.filter(s => { return s.key === 'test_invoice'});
			if (test_invoice_filter[0].value.includes(booking.status_id)) {
				/** Test Invoice */
				if (booking.has_cinv) {
					is_able = false;
				} else {
					is_able = true;
				}
			}

			const invoiced_filter = Status_Items.filter(s => { return s.key === 'invoiced'});
			if (invoiced_filter[0].value.includes(booking.status_id)) {
				/** Invoiced */
				is_able = false;
			}

			const note_filter = Status_Items.filter(s => { return s.key === 'note'});
			if (note_filter[0].value.includes(booking.status_id)) {
				/** Test Credit Note */
				is_able = false;
			}

			if (booking.rev_id && booking.rev_id === Planned_Value) {
				/** Reversed */
				is_able = false;
			}

			if (booking.rev_id && booking.rev_id > Planned_Value) {
				/** Reversal */
				is_able = false;
			}

			return is_able;
		},
		_calculateBookingAmount(booking, is_commission_amount=false) {
			const new_booking = JSON.parse(JSON.stringify(booking));

			/** supplier, supplier[0] -> supplier_rate, supplier[1] -> supplier_amount */
			const units = Decimal(new_booking.units);
			const supplier_rate = Decimal(new_booking.supplier[0]);
			const supplier_amount = supplier_rate.times(units).toDecimalPlaces(Decimal_Places);
			new_booking.supplier[1] = supplier_amount.toFixed(2);

			/** commission, commission[0] -> commission_amount, commission[1] -> commission_rate */
			let commission_amount = 0;
			let commission_rate = 0;

			if (is_commission_amount) {
				commission_amount = Decimal(new_booking.commission[0]).toDecimalPlaces(Decimal_Places);
				commission_rate = supplier_amount.equals(0) ? new Decimal(0) : commission_amount.div(supplier_amount).times(100).toDecimalPlaces(Decimal_Places);
				new_booking.commission[1] = commission_rate.toFixed(2);
			} else {
				commission_rate = Decimal(new_booking.commission[1]).toDecimalPlaces(Decimal_Places);
				commission_amount = supplier_amount.times(commission_rate).times(0.01).toDecimalPlaces(Decimal_Places);
				new_booking.commission[0] = commission_amount.toFixed(2);
			}

			/** net, net[0] -> net_amount */
			const ex_rate = new Decimal(this.exchangeRate).div(100).toDecimalPlaces(Decimal_Places);
			const ex_rate_cost = new Decimal(this.costRate.rate).toDecimalPlaces(Decimal_Places);
			const ex_rate_schedule = new Decimal(this.scheduleRate.rate).toDecimalPlaces(Decimal_Places);

			const supplier_amount_sys = supplier_amount.div(ex_rate_cost).toDecimalPlaces(Decimal_Places);
			const commission_amount_sys = commission_amount.div(ex_rate_cost).toDecimalPlaces(Decimal_Places);
			const net_amount_sys = supplier_amount_sys.minus(commission_amount_sys).toDecimalPlaces(Decimal_Places);

			const net_amount_schedule = net_amount_sys.times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
			const margin_amount_sys = net_amount_sys.times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
			const margin_amount_schedule = margin_amount_sys.times(ex_rate).toDecimalPlaces(Decimal_Places);

			const net_schedule = net_amount_schedule.plus(margin_amount_schedule).toDecimalPlaces(Decimal_Places);
			new_booking.net = [net_schedule.toFixed(2)];
			
			/** markup */
			if (new_booking.foc === true) {
				new_booking.markup = ['0.00', '0.00'];
				new_booking.bill = ['0.00'];
				new_booking.revenue = ['0.00'];
			} else {
				let make_up_amount = 0;
				let make_up_perc = 0;
				let rebate = 0;
				
				const mode = new_booking.mode.value;

				if (mode === 0) {
					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) ? new Decimal(this.markupPerc).toDecimalPlaces(Decimal_Places) : current_markup_perc;
					const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					make_up_amount = net_schedule.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 1) {					
					make_up_amount = this.costCurrency.id === this.scheduleCurrency.id ? commission_amount : commission_amount.times(ex_rate_schedule).div(ex_rate_cost).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 2) {
					const supplier_amount_tmp = this.costCurrency.id === this.scheduleCurrency.id 
						? supplier_amount 
						: supplier_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);

					const commission_amount_tmp = this.costCurrency.id === this.scheduleCurrency.id 
						? commission_amount 
						: commission_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);

					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) 
						? new Decimal(this.rebatePerc).toDecimalPlaces(Decimal_Places) 
						: current_markup_perc;
					make_up_amount = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);

					rebate = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
					make_up_amount = commission_amount_tmp.minus(rebate).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 3) {
					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) ? new Decimal(this.markupPerc).toDecimalPlaces(Decimal_Places) : current_markup_perc;

					const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					make_up_amount = net_schedule.times(make_up_perc).div(100).plus(commission_amount).toDecimalPlaces(Decimal_Places);
				}
				
				new_booking.markup = [mode === 2 ? rebate.toFixed(2) : make_up_amount.toFixed(2), make_up_perc.toFixed(2)];

				/** bill to client */
				const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
				const net_from_two_digital = Number(net_from_field.toFixed(2));
				const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

				const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
				new_booking.bill = [bill_two_digital.toFixed(2)];

				/** revenue */
				const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
				new_booking.revenue = [revenue.toFixed(2)];
			}
			
			return new_booking;
		},
		_calculateBookingNet(booking) {
			const new_booking = JSON.parse(JSON.stringify(booking));

			/** supplier, supplier[0] -> supplier_rate, supplier[1] -> supplier_amount */
			const units = Decimal(new_booking.units);
			const supplier_rate = Decimal(new_booking.supplier[0]);
			const supplier_amount = supplier_rate.times(units).toDecimalPlaces(Decimal_Places);

			/** commission, commission[0] -> commission_amount, commission[1] -> commission_rate */
			const commission_amount = Decimal(new_booking.commission[0]).toDecimalPlaces(Decimal_Places);

			/** net, net[0] -> net_amount */
			const ex_rate = new Decimal(this.exchangeRate).div(100).toDecimalPlaces(Decimal_Places);
			const ex_rate_cost = new Decimal(this.costRate.rate).toDecimalPlaces(Decimal_Places);
			const ex_rate_schedule = new Decimal(this.scheduleRate.rate).toDecimalPlaces(Decimal_Places);

			const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
			const net_sys = new Decimal(net_schedule).div(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
			const net_cost = net_sys.times(ex_rate_cost).toDecimalPlaces(Decimal_Places);

			const margin_cost = supplier_amount.minus(commission_amount).times(ex_rate).toDecimalPlaces(Decimal_Places);
			const commission_amount_cost = supplier_amount.minus(net_cost).plus(margin_cost).toDecimalPlaces(Decimal_Places);
			new_booking.commission[0] = commission_amount_cost.toFixed(2);

			if (supplier_amount.equals(0)) {
				const commission_rate_cost = 0;
				new_booking.commission[1] = Number(commission_rate_cost).toFixed(2);
			} else {
				const commission_rate_cost = supplier_amount.minus(net_cost).div(supplier_amount).times(100).toDecimalPlaces(Decimal_Places);
				new_booking.commission[1] = Number(commission_rate_cost).toFixed(2);
			}

			/** markup */
			if (new_booking.foc === true) {
				new_booking.markup = ['0.00', '0.00'];
				new_booking.bill = ['0.00'];
				new_booking.revenue = ['0.00'];
			} else {
				let make_up_amount = 0;
				let make_up_perc = 0;
				let rebate = 0;
				
				const mode = new_booking.mode.value;

				if (mode === 0) {
					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) ? new Decimal(this.markupPerc).toDecimalPlaces(Decimal_Places) : current_markup_perc;
					const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					make_up_amount = net_schedule.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 1) {					
					make_up_amount = this.costCurrency.id === this.scheduleCurrency.id 
						? commission_amount_cost 
						: commission_amount_cost.times(ex_rate_schedule).div(ex_rate_cost).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 2) {
					const supplier_amount_tmp = this.costCurrency.id === this.scheduleCurrency.id 
						? supplier_amount 
						: supplier_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);

					const commission_amount_tmp = this.costCurrency.id === this.scheduleCurrency.id 
						? commission_amount_cost 
						: commission_amount_cost.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);

					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) 
						? new Decimal(this.rebatePerc).toDecimalPlaces(Decimal_Places) 
						: current_markup_perc;

					rebate = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
					make_up_amount = commission_amount_tmp.minus(rebate).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 3) {
					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) ? new Decimal(this.markupPerc).toDecimalPlaces(Decimal_Places) : current_markup_perc;

					const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					make_up_amount = net_schedule.times(make_up_perc).div(100).plus(commission_amount_cost).toDecimalPlaces(Decimal_Places);
				}
				
				new_booking.markup = [mode === 2 ? rebate.toFixed(2) : make_up_amount.toFixed(2), make_up_perc.toFixed(2)];

				/** bill to client */
				const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
				const net_from_two_digital = Number(net_from_field.toFixed(2));
				const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

				const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
				new_booking.bill = [bill_two_digital.toFixed(2)];

				/** revenue */
				const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
				new_booking.revenue = [revenue.toFixed(2)];
			}
			
			return new_booking;
		},
		_calculateBookingFOC(booking) {
			const new_booking = JSON.parse(JSON.stringify(booking));

			/** markup */
			if (new_booking.foc === true) {
				new_booking.markup = ['0.00', '0.00'];
				new_booking.bill = ['0.00'];
				new_booking.revenue = ['0.00'];
			} else {
				const units = Decimal(new_booking.units);
				const supplier_rate = Decimal(new_booking.supplier[0]);
				const supplier_amount = supplier_rate.times(units).toDecimalPlaces(Decimal_Places);
				const commission_amount = Decimal(new_booking.commission[0]).toDecimalPlaces(Decimal_Places);

				const ex_rate_cost = new Decimal(this.costRate.rate).toDecimalPlaces(Decimal_Places);
				const ex_rate_schedule = new Decimal(this.scheduleRate.rate).toDecimalPlaces(Decimal_Places);
			
				let make_up_amount = 0;
				let make_up_perc = 0;
				let rebate = 0;
				
				const mode = new_booking.mode.value;

				if (mode === 0) {
					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) ? new Decimal(this.markupPerc).toDecimalPlaces(Decimal_Places) : current_markup_perc;
					const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					make_up_amount = net_schedule.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 1) {					
					make_up_amount = this.costCurrency.id === this.scheduleCurrency.id ? commission_amount : commission_amount.times(ex_rate_schedule).div(ex_rate_cost).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 2) {
					const supplier_amount_tmp = this.costCurrency.id === this.scheduleCurrency.id 
						? supplier_amount 
						: supplier_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);

					const commission_amount_tmp = this.costCurrency.id === this.scheduleCurrency.id 
						? commission_amount 
						: commission_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);

					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) 
						? new Decimal(this.rebatePerc).toDecimalPlaces(Decimal_Places) 
						: current_markup_perc;
					make_up_amount = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);

					rebate = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
					make_up_amount = commission_amount_tmp.minus(rebate).toDecimalPlaces(Decimal_Places);
				}
				if (mode === 3) {
					const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					make_up_perc = current_markup_perc.equals(0) ? new Decimal(this.markupPerc).toDecimalPlaces(Decimal_Places) : current_markup_perc;

					const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					make_up_amount = net_schedule.times(make_up_perc).div(100).plus(commission_amount).toDecimalPlaces(Decimal_Places);
				}
				
				new_booking.markup = [mode === 2 ? rebate.toFixed(2) : make_up_amount.toFixed(2), make_up_perc.toFixed(2)];
				
				/** bill to client */
				const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
				const net_from_two_digital = Number(net_from_field.toFixed(2));
				const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

				const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
				new_booking.bill = [bill_two_digital.toFixed(2)];

				/** revenue */
				const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
				new_booking.revenue = [revenue.toFixed(2)];
			}

			return new_booking;
		},
		_calculateBookingMode(booking) {
			const new_booking = JSON.parse(JSON.stringify(booking));

			const units = Decimal(new_booking.units);
			const supplier_rate = Decimal(new_booking.supplier[0]);
			const supplier_amount = supplier_rate.times(units).toDecimalPlaces(Decimal_Places);
			const commission_amount = Decimal(new_booking.commission[0]).toDecimalPlaces(Decimal_Places);

			const ex_rate_cost = new Decimal(this.costRate.rate).toDecimalPlaces(Decimal_Places);
			const ex_rate_schedule = new Decimal(this.scheduleRate.rate).toDecimalPlaces(Decimal_Places);
				
			let make_up_amount = 0;
			let make_up_perc = 0;
			let rebate = 0;
				
			const mode = new_booking.mode.value;
			if (mode === 0) {
				make_up_perc = new Decimal(this.markupPerc).toDecimalPlaces(Decimal_Places);
				const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
				make_up_amount = net_schedule.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
			}
			if (mode === 1) {					
				make_up_amount = this.costCurrency.id === this.scheduleCurrency.id 
					? commission_amount 
					: commission_amount.times(ex_rate_schedule).div(ex_rate_cost).toDecimalPlaces(Decimal_Places);
			}
			if (mode === 2) {
				const supplier_amount_tmp = this.costCurrency.id === this.scheduleCurrency.id 
					? supplier_amount
					: supplier_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
					
				const commission_amount_tmp = this.costCurrency.id === this.scheduleCurrency.id 
					? commission_amount
					: commission_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);

				make_up_perc = new Decimal(this.rebatePerc).toDecimalPlaces(Decimal_Places);

				rebate = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
				make_up_amount = commission_amount_tmp.minus(rebate).toDecimalPlaces(Decimal_Places);
			}
			if (mode === 3) {
				const current_markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
				make_up_perc = current_markup_perc.equals(0) ? new Decimal(this.markupPerc).toDecimalPlaces(Decimal_Places) : current_markup_perc;

				const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
				make_up_amount = net_schedule.times(make_up_perc).div(100).plus(commission_amount).toDecimalPlaces(Decimal_Places);
			}
			
			new_booking.markup = [mode === 2 ? rebate.toFixed(2) : make_up_amount.toFixed(2), make_up_perc.toFixed(2)];
			
			/** bill to client */
			const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
			const net_from_two_digital = Number(net_from_field.toFixed(2));
			const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

			const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
			new_booking.bill = [bill_two_digital.toFixed(2)];

			/** revenue */
			const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
			new_booking.revenue = [revenue.toFixed(2)];

			return new_booking;
		},
		_calculateBaseMode(booking, is_markup_amount, is_markup_rate, is_bill) {
			/** calculate markup_amount, markup_rate, bill and revenue */
			const new_booking = JSON.parse(JSON.stringify(booking));

			const mode = new_booking.mode.value;
			if (mode === 0) {
				const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);

				if (is_markup_amount) {
					const make_up_amount = new Decimal(new_booking.markup[0]).toDecimalPlaces(Decimal_Places);
					const make_up_perc = net_schedule.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : make_up_amount.div(net_schedule).times(100).toDecimalPlaces(Decimal_Places);
					new_booking.markup[1] = make_up_perc.toFixed(2);

					/** bill to client */
					const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					const net_from_two_digital = Number(net_from_field.toFixed(2));
					const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

					const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
					new_booking.bill = [bill_two_digital.toFixed(2)];

					/** revenue */
					const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
					new_booking.revenue = [revenue.toFixed(2)];
				}
				if (is_markup_rate) {
					const make_up_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					const make_up_amount = net_schedule.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
					new_booking.markup[0] = make_up_amount.toFixed(2);

					/** bill to client */
					const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					const net_from_two_digital = Number(net_from_field.toFixed(2));
					const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

					const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
					new_booking.bill = [bill_two_digital.toFixed(2)];

					/** revenue */
					const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
					new_booking.revenue = [revenue.toFixed(2)];
				}
				if (is_bill) {
					const units = Decimal(new_booking.units);
					const markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					const commission_perc = new Decimal(new_booking.commission[1]).toDecimalPlaces(Decimal_Places);
					const ex_rate_cost = new Decimal(this.costRate.rate).toDecimalPlaces(Decimal_Places);
					const ex_rate_schedule = new Decimal(this.scheduleRate.rate).toDecimalPlaces(Decimal_Places);

					let lvmarkDown = new Decimal(0).toDecimalPlaces(Decimal_Places);
					if (!markup_perc.equals(0)) {
						const lvmarkDown_tmp = this.markdownFromMarkup(markup_perc.toNumber(), Decimal_Places);
						lvmarkDown = new Decimal(lvmarkDown_tmp).toDecimalPlaces(Decimal_Places);
					}

					const bill = new Decimal(new_booking.bill[0]).toDecimalPlaces(Decimal_Places);
					const make_up_amount = bill.times(lvmarkDown).div(100).toDecimalPlaces(Decimal_Places);
					new_booking.markup[0] = make_up_amount.toFixed(2);

					const net_amount = bill.minus(make_up_amount).toDecimalPlaces(Decimal_Places);
					new_booking.net = [net_amount.toFixed(2)];

					const revenue = bill.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : bill.minus(net_amount).div(bill).times(100).toDecimalPlaces(Decimal_Places);
					new_booking.revenue = [revenue.toFixed(2)];

					let lvMarkUp = new Decimal(0).toDecimalPlaces(Decimal_Places);
					if (!commission_perc.equals(0)) {
						const lvMarkUp_tmp = this.markupFromMarkdown(commission_perc.toNumber(), Decimal_Places);
						lvMarkUp = new Decimal(lvMarkUp_tmp).toDecimalPlaces(Decimal_Places);
					}
					const net_amount_tmp = this.costCurrency.id === this.scheduleCurrency.id ? net_amount : net_amount.div(ex_rate_schedule).times(ex_rate_cost).toDecimalPlaces(Decimal_Places);
					const commission_amount_fc = net_amount_tmp.times(lvMarkUp).div(100).toDecimalPlaces(Decimal_Places);
					new_booking.commission[0] = commission_amount_fc.toFixed(2);

					const supplier_amount = net_amount_tmp.plus(commission_amount_fc).toDecimalPlaces(Decimal_Places);
					new_booking.supplier[1] = supplier_amount.toFixed(2);					

					const supplier_rate = supplier_amount.div(units).toDecimalPlaces(Decimal_Places);
					new_booking.supplier[0] = supplier_rate.toFixed(2);
				}
			}
			if (mode === 2) {
				const supplier_amount = new Decimal(new_booking.supplier[1]).toDecimalPlaces(Decimal_Places);
				const ex_rate_cost = new Decimal(this.costRate.rate).toDecimalPlaces(Decimal_Places);
				const ex_rate_schedule = new Decimal(this.scheduleRate.rate).toDecimalPlaces(Decimal_Places);
				const supplier_amount_tmp = this.costCurrency.id === this.scheduleCurrency.id ? supplier_amount : supplier_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
				
				if (is_markup_amount) {
					const rebate = new Decimal(new_booking.markup[0]).toDecimalPlaces(Decimal_Places);
					const make_up_perc = supplier_amount_tmp.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : rebate.div(supplier_amount_tmp).times(100).toDecimalPlaces(Decimal_Places);
					new_booking.markup[1] = make_up_perc.toFixed(2);

					/** bill to client */
					const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					const commission_amount_from_field = new Decimal(new_booking.commission[0]).toDecimalPlaces(Decimal_Places);
					const make_up_amount_from_field = new Decimal(new_booking.markup[0]).toDecimalPlaces(Decimal_Places);

					const net_from_two_digital = Number(net_from_field.toFixed(2));
					const commission_amount_two_digital = Number(commission_amount_from_field.toFixed(2));
					const make_up_amount_two_digital = Number(make_up_amount_from_field.toFixed(2));

					const bill_two_digital = net_from_two_digital + commission_amount_two_digital - make_up_amount_two_digital;
					new_booking.bill = [bill_two_digital.toFixed(2)];
				
					/** revenue */
					const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
					new_booking.revenue = [revenue.toFixed(2)];
				}
				if (is_markup_rate) {
					const make_up_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					const rebate = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
					new_booking.markup[0] = rebate.toFixed(2);

					/** bill to client */
					const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					const commission_amount_from_field = new Decimal(new_booking.commission[0]).toDecimalPlaces(Decimal_Places);
					const make_up_amount_from_field = new Decimal(new_booking.markup[0]).toDecimalPlaces(Decimal_Places);
					
					const net_from_two_digital = Number(net_from_field.toFixed(2));
					const commission_amount_two_digital = Number(commission_amount_from_field.toFixed(2));
					const make_up_amount_two_digital = Number(make_up_amount_from_field.toFixed(2));

					const bill_two_digital = net_from_two_digital + commission_amount_two_digital - make_up_amount_two_digital;
					new_booking.bill = [bill_two_digital.toFixed(2)];

					/** revenue */
					const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
					new_booking.revenue = [revenue.toFixed(2)];
				}
				if (is_bill) {
					const units = Decimal(new_booking.units);
					const markup_perc = new Decimal(new_booking.markup[1]).toDecimalPlaces(Decimal_Places);
					const commission_perc = new Decimal(new_booking.commission[1]).toDecimalPlaces(Decimal_Places);

					const bill = new Decimal(new_booking.bill[0]);
					const supplier_amount_div = bill.div(100 - markup_perc).times(100).toDecimalPlaces(2);
					const commission_amount_div = supplier_amount_div.times(commission_perc).div(100).toDecimalPlaces(2);

					const net_amount = supplier_amount_div.minus(commission_amount_div).toDecimalPlaces(Decimal_Places);
					const rebate = bill.minus(net_amount).toDecimalPlaces(Decimal_Places);
					const markup_amount = rebate.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : commission_amount_div.minus(rebate).toDecimalPlaces(Decimal_Places);
					const revenue = bill.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : bill.minus(net_amount).div(bill).times(100).toDecimalPlaces(Decimal_Places);
					
					const supplier_amount = this.costCurrency.id === this.scheduleCurrency.id 
						? supplier_amount_div
						: supplier_amount_div.div(ex_rate_schedule).times(ex_rate_cost).toDecimalPlaces(Decimal_Places);
					const supplier_rate = supplier_amount.div(units).toDecimalPlaces(Decimal_Places);
					const commission_amount = supplier_amount.times(commission_perc).div(100).toDecimalPlaces(Decimal_Places);

					new_booking.supplier[0] = supplier_rate.toFixed(2);
					new_booking.supplier[1] = supplier_amount.toFixed(2);
					new_booking.commission[0] = commission_amount.toFixed(2);
					new_booking.net = [net_amount.toFixed(2)];
					new_booking.markup[0] = markup_amount.toFixed(2);
					new_booking.revenue = [revenue.toFixed(2)];
				}
			}
			if (mode === 3) {
				const net_schedule = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
				const commission_amount = new Decimal(new_booking.commission[0]).toDecimalPlaces(Decimal_Places);

				if (is_markup_amount) {
					const make_up_amount = new Decimal(new_booking.markup[0]).toDecimalPlaces(Decimal_Places);
					const make_up_perc = net_schedule.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : make_up_amount.minus(commission_amount).times(100).div(net_schedule);
					new_booking.markup[1] = make_up_perc.toFixed(2);

					/** bill to client */
					const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					const net_from_two_digital = Number(net_from_field.toFixed(2));
					const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

					const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
					new_booking.bill = [bill_two_digital.toFixed(2)];

					/** revenue */
					const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
					new_booking.revenue = [revenue.toFixed(2)];
				}
				if (is_markup_rate) {
					const make_up_perc = new Decimal(new_booking.markup[1]).div(100).toDecimalPlaces(Decimal_Places);
					const make_up_amount = net_schedule.times(make_up_perc).plus(commission_amount).toDecimalPlaces(Decimal_Places);
					new_booking.markup[0] = make_up_amount.toFixed(2);

					/** bill to client */
					const net_from_field = new Decimal(new_booking.net[0]).toDecimalPlaces(Decimal_Places);
					const net_from_two_digital = Number(net_from_field.toFixed(2));
					const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));

					const bill_two_digital = net_from_two_digital + make_up_amount_two_digital;
					new_booking.bill = [bill_two_digital.toFixed(2)];

					/** revenue */
					const revenue = bill_two_digital === 0 ? 0 : (bill_two_digital - net_from_two_digital)/bill_two_digital * 100;
					new_booking.revenue = [revenue.toFixed(2)];
				}
				if (is_bill) {
					const bill = new Decimal(new_booking.bill[0]).toDecimalPlaces(Decimal_Places);

					const make_up_amount = net_schedule.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : bill.minus(net_schedule).toDecimalPlaces(Decimal_Places);
					const make_up_perc = net_schedule.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : make_up_amount.minus(commission_amount).times(100).div(net_schedule);
					new_booking.markup = [make_up_amount.toFixed(2), make_up_perc.toFixed(2)];

					const revenue = bill.equals(0) ? new Decimal(0).toDecimalPlaces(Decimal_Places) : bill.minus(net_schedule).div(bill).times(100).toDecimalPlaces(Decimal_Places);
					new_booking.revenue = [revenue.toFixed(2)];
				}
			}

			return new_booking;
		},
		_getNewIndex() {
			const index_all = this.radio_list.map(b => { return Number((b.index.split('_'))[1]) });
			index_all.sort();
			const new_index = index_all.length === 0 ? '0_0': `0_${index_all[index_all.length - 1] + 1}`;
			return new_index;
		},
		markdownFromMarkup(pvMarkup, pvRounding=2) {
			let markdown = 0;

			const rnd = new Decimal(pvMarkup).toDecimalPlaces(2);

			if (rnd.equals(-100)) {
				markdown = 0.00;
			} else {
				const pvMarkup_new = 100.0 - (10000.00 / (100.00 + pvMarkup ));
				markdown = new Decimal(pvMarkup_new).toDecimalPlaces(pvRounding);
			}
			
			return markdown.toNumber();
		},
		markupFromMarkdown(pvMarkdown, pvRounding=2) {
			let markup = 0;

			const rnd = new Decimal(pvMarkdown).toDecimalPlaces(2);

			if (rnd.equals(100)) {
				markup = 0.00;
			} else {
				const pvMarkdown_new = (10000.00 / (100 - pvMarkdown)) - 100.0;
				markup = new Decimal(pvMarkdown_new).toDecimalPlaces(pvRounding);
			}

			return markup.toNumber();
		}
	}
}
</script>

<style lang="scss" scoped>
.title-sytle {
  font-family: Roboto;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
}
.selector-item-style {
	color: #605AF6;
}
.background-color {
	background-color: #E8EAEC;
}
.optional-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 12px;

	text-align: right;
	letter-spacing: 0.4px;
	color: #37495F;
}
.font-normal-style {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	// line-height: 36px;
	letter-spacing: 0.5px;
	vertical-align: middle;
}
.font-bold-style {
	font-family: Roboto;
	font-weight: 500;
	font-size: 14px;
	// line-height: 36px;
	letter-spacing: 0.5px;
	vertical-align: middle;
}
.font-over-long {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.text-style {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 36px;
	letter-spacing: 0.5px;
	text-align: center;
	vertical-align: middle;
}
.text-nomal-color {
	color: rgba(25, 42, 62, 0.7);
}
.text-nomal-disable-color {
	color: rgba(25, 42, 62, 0.3);
}
.header-background-color {
	background-color: #EAEAEA;
}
.font-header-style {
	color: #192A3E;
}
.reversal-text-color {
	color: #F45252;
}
.disable-btn.v-btn--disabled {
  /* Re-enable pointer events so the cursor style can be applied */
  pointer-events: auto !important;
  /* Set the desired cursor style */
  cursor: not-allowed !important; 
}
.weekday-block-plan {
	font-size: 14px;
	color: #FFFFFF;
	background-color: #4742C6;
	text-align: center;
}
.weekday-block-other {
	font-size: 14px;
	color: #192A3E;
	background-color: rgba(96, 90, 246, 0.25);
	text-align: center;
}
.weekday-block {
	font-size: 14px;
	color: #192A3E;
	background-color: #FFFFFF;
	text-align: center;
}

::v-deep {
	.select-field.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
		min-height: 36px;
		max-width: 400px;
	}
	.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding-right: 4px;
    padding-left: 4px;
  }
	.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
    padding-left: 0;
		padding-right: 0;
	}
  .select-in-cell.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
    min-height: 32px;
  }
	.select-exchange.v-text-field .v-input__control .v-input__slot {
		min-height: auto !important;
		display: flex !important;
		align-items: center !important;
	}
  .field-in-cell.v-text-field .v-input__control .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
		padding: 0;
  }
	.field-in-cell input {
		padding-right: 4px;
		text-align: end;
	}
  .field-in-cell.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
    margin-top: 0;
    margin-right: 4px;
  }
	 .field-in-cell-name.v-text-field .v-input__control .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
		padding: 0;
  }
	.field-in-cell-name input {
		padding-left: 4px;
	}
	.reversal-text-color input {
		color:#F45252;
	}
  .field-in-top.theme--light.v-input input {
    color: #605AF6;
  }
	.reversal-row {
		background-color: #FFF1F1 !important;
	}
	.date-in-cell.v-text-field fieldset, .v-text-field .v-input__control{
    font-family: Roboto;
		font-weight: 400;
		font-size: 14px;
		line-height: 36px;
		letter-spacing: 0.5px;
  }
}
</style>